import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import Solutions2 from '../../components/Solutions/Solutions';
import { 
  FaGlobeAsia, 
  FaFileContract, 
  FaChartLine, 
  FaChartBar,
  FaDesktop,
  FaShieldAlt,
  FaNetworkWired,
  FaCalculator
} from 'react-icons/fa';

import './Solutions.css';

const solutionsContent = {
  title: "我们的服务",
  subtitle: "\"数据驱动发展，智能引领未来\"",
  description: [
    "数据是企业数字化转型的生命线。它是一项战略资产，帮助企业发现新机遇、识别潜在威胁、了解客户需求变化和竞争格局。数据科学能够发现数据中的模式，告诉您客户的行为习惯和兴趣所在，指导您何时何地供应本季新品，预测网络中哪些组件可能出现故障，识别潜在的欺诈风险。最终，它将为您的组织开启新的性能水平。",
    "我们帮助企业将原始数据转化为战略性商业洞察。我们提供数据科学服务，为科技企业和服务提供商执行复杂的分析。我们的专业团队帮助企业释放数据的力量，开发定制化的数据分析工具，将大数据转化为对您业务有意义的信息。",
    "我们可以通过扩展项目的某个部分或从头到尾完整处理整个项目来实现这一目标。我们经验丰富的数据分析团队在实际业务环境中部署、运营和支持分析方面拥有多年经验。"
  ],
  image: "/images/services/image.png"
};

const solutionsCards = {
  title: "软件解决方案",
  cards: [
    {
      icon: <FaDesktop className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '跨境贸易&进出口管理',
      path: '/trade',
      description: '智能化跨境贸易管理系统，提供一站式贸易流程管理，实现业务全程数字化监控与优化。'
    },
    {
      icon: <FaShieldAlt className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '海关报关，进出口申报',
      path: '/customs', 
      description: '全面的贸易合规检查与风险评估系统，确保贸易活动符合国际规范，有效防范贸易风险。'
    },
    {
      icon: <FaNetworkWired className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '投资与风险管理',
      path: '/investment',
      description: '整合供应链各环节资源，提供实时物流追踪，优化供应链协同效率。'
    },
    {
      icon: <FaCalculator className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '股票&证券',
      path: '/stock',
      description: '专业的国际贸易财务处理系统，提供精准的关税计算、汇率管理及财务结算服务。'
    }
  ]
};

const Solutions = () => {
  return (
    <div className="solutions-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...solutionsContent} />
      <Solutions2 {...solutionsCards} />
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Solutions; 